import axios from 'axios';
import { CONSUMER_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const postStoreCustomerAccountTransaction = (storeCustomerId, storeId, data) => {
  return axios({
    method: 'post',
    url:
      CONSUMER_BASE_URL +
      '/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      storeCustomerId +
      '/store-customer-account-transaction', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};
